<!-- address -->
<fieldset class="form-group" [formGroup]="form">
  <legend class="title-fieldset">Adresse<span *ngIf="legendDetails">{{legendDetails}}</span></legend>

  <div class="form-group row">
    <app-input [label]="'address.address'" [formControl]="form_street" [autocompletionType]="'address'"
      (clickedOption)="onClickOption($event)"
      [hint]="!form_street.value ? 'Recherche à partir de 5 caractères' : null"></app-input>
    <app-input [label]="'address.complement'" [formControl]="form_complement"></app-input>
  </div>
  <div class="form-group row">
    <app-input [label]="'address.postalCode'" [formControl]="form_postalCode"></app-input>
    <app-input [label]="'address.city'" [formControl]="form_city"></app-input>
    <!--<app-input [label]="'address.country'" [formControl]="form_country" [size]="4"></app-input>-->
  </div>
</fieldset>